// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2d6_G","checkboxCol":"Table_checkboxCol__2o8rW","emailCol":"Table_emailCol__nwnJa","actionCol":"Table_actionCol__kO8DV"};